export const WIV_PRICE = 69;
export const WIV_VIDEO_URL = 'https://fast.wistia.com/embed/medias/p6om5icgjx';
